var _linearGradient, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    viewBox: "0 0 800 800",
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.861,
    x2: 0.163,
    y1: 0.189,
    y2: 0.853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6509e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebac6"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h800v800h-800z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 390,
    fill: "url(#a)",
    r: 390,
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.145 151.074-56.353-136.674a12.014 12.014 0 0 1 -.692-3.877 10.71 10.71 0 0 1 2.769-7.616 9.7 9.7 0 0 1 7.477-2.907 10.1 10.1 0 0 1 5.815 1.939 12.327 12.327 0 0 1 4.015 5.124l53.584 133.764 53.584-133.765a12.325 12.325 0 0 1 4.015-5.124 10.1 10.1 0 0 1 5.815-1.938 9.7 9.7 0 0 1 7.477 2.908 10.71 10.71 0 0 1 2.769 7.616 12.014 12.014 0 0 1 -.693 3.877l-56.352 136.673c-3.184 7.062-7.892 10.524-14.123 10.524h-4.984c-6.231.002-10.938-3.462-14.123-10.524z",
    transform: "translate(190.601 319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.608 157.136a10.022 10.022 0 0 1 -2.908-7.336v-138.476a10.574 10.574 0 0 1 2.907-7.478 9.618 9.618 0 0 1 7.339-3.046h91.521a9.094 9.094 0 0 1 6.923 2.908 9.308 9.308 0 0 1 2.908 6.924 8.8 8.8 0 0 1 -2.908 6.785 9.73 9.73 0 0 1 -6.923 2.769h-81v50.4h72.833a9.1 9.1 0 0 1 6.923 2.908 9.531 9.531 0 0 1 2.908 6.924 8.8 8.8 0 0 1 -2.908 6.785 9.731 9.731 0 0 1 -6.923 2.769h-72.831v50.681h81a9.094 9.094 0 0 1 6.923 2.908 9.308 9.308 0 0 1 2.908 6.924 8.8 8.8 0 0 1 -2.908 6.785 9.73 9.73 0 0 1 -6.923 2.77h-91.523a9.046 9.046 0 0 1 -7.338-2.904z",
    transform: "translate(237.366 319.308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.566 147.2-56.353-136.676c-3.184-7.062-7.892-10.524-14.122-10.524h-4.985c-6.231 0-10.938 3.462-14.123 10.524l-24.507 59.543h-18.553a10.165 10.165 0 0 0 -10.107 10.109v.138a10.165 10.165 0 0 0 10.107 10.109h9.969l-23.4 56.774a12.015 12.015 0 0 0 -.692 3.877 10.71 10.71 0 0 0 2.769 7.616 9.7 9.7 0 0 0 7.477 2.908 10.1 10.1 0 0 0 5.815-1.939 12.325 12.325 0 0 0 4.015-5.123l25.754-64.113h17.723a10.165 10.165 0 0 0 10.107-10.109v-.277a10.165 10.165 0 0 0 -10.107-10.109h-9.553l19.8-49.158 53.583 133.765a12.325 12.325 0 0 0 4.015 5.124 10.1 10.1 0 0 0 5.815 1.939 9.7 9.7 0 0 0 7.477-2.908 10.71 10.71 0 0 0 2.769-7.616 9.178 9.178 0 0 0 -.693-3.874z",
    transform: "translate(153.565 319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.966 147.2-56.353-136.676c-3.184-7.062-7.892-10.524-14.122-10.524h-4.985c-6.23 0-10.938 3.462-14.123 10.524l-24.507 59.543h-18.553a10.165 10.165 0 0 0 -10.108 10.109v.138a10.165 10.165 0 0 0 10.108 10.109h9.969l-23.4 56.777a12.015 12.015 0 0 0 -.692 3.877 10.71 10.71 0 0 0 2.769 7.616 9.7 9.7 0 0 0 7.477 2.908 10.1 10.1 0 0 0 5.815-1.939 12.325 12.325 0 0 0 4.015-5.123l25.754-64.116h17.861a10.165 10.165 0 0 0 10.109-10.109v-.277a10.165 10.165 0 0 0 -10.109-10.108h-9.554l19.663-49.158 53.583 133.765a12.325 12.325 0 0 0 4.015 5.124 10.1 10.1 0 0 0 5.815 1.939 9.7 9.7 0 0 0 7.477-2.908 10.71 10.71 0 0 0 2.769-7.616 9.184 9.184 0 0 0 -.693-3.875z",
    transform: "translate(106.8 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.61fbbbc512b3caa01c4e1050d47e9664.svg";
export { ForwardRef as ReactComponent };